import { chartSeriesColors } from "./enum.data";
import { customKey } from "./enum.data";
import { styleConfig } from "../config/panelConf";
import { widgetTypeMap } from "./enum.data";
import { defaultDrillField, defaultFilterField } from "./panelConf";
import html2canvas from "html2canvas";

function getMeasures(data) {
  return (
    data
      ?.filter((item) => !!item)
      .find((item) => item.queryType === "values") ?? {}
  );
}

function getColorDimensions(data) {
  const columns = data.find((item) => item.queryType === "columns") ?? {};
  const rows = data.find((item) => item.queryType === "rows") ?? {};
  const drillField = data.find((item) => item.alias === "drill") ?? {};
  let cloneColumns = JSON.parse(JSON.stringify(columns));
  if (
    columns.chooseFields?.[0] &&
    drillField.drillFieldsBreadcrumb?.length > 1 &&
    drillField.chooseFields[0].unitCode === columns.chooseFields[0].unitCode
  ) {
    cloneColumns.chooseFields = [
      drillField["chooseFields"][drillField.drillFieldsBreadcrumb.length - 1],
    ];
  }
  // return data.find((item) => item.queryType === 'columns') ?? {};
  return cloneColumns;
}

function getDimensions(data, isRows = false) {
  let rows = data.find((item) => item.queryType === "rows") ?? {};
  if (isRows) {
    return rows;
  }
  const isHasAny = data.some(
    (item) => item.type === "any" && !["drill", "filter"].includes(item.alias)
  );
  const colorDim =
    data.find(
      (item) => item.alias === "dimension" && item.queryType === "columns"
    )?.chooseFields ?? [];
  const measure =
    data.find(
      (item) => item.alias === "measure" && item.queryType === "columns"
    )?.chooseFields ?? [];
  const drillField = data.find((item) => item.alias === "drill") ?? {};
  const drillFieldClone = JSON.parse(JSON.stringify(drillField));
  if (drillField.drillFieldsBreadcrumb?.length > 1) {
    const item =
      drillFieldClone.chooseFields[drillField.drillFieldsBreadcrumb.length - 1];
    drillFieldClone.chooseFields = [item];
    // 获取 rows.chooseFields 的所有 unitCode 列表
    const rowsUnitCodes = rows.chooseFields?.map((v) => v.unitCode) ?? [];
    // 检查 measure 数组中是否有任何一个 unitCode 存在于 rows.chooseFields 中
    const hasMeasureInRows =
      measure.length > 0 &&
      measure.some((m) => rowsUnitCodes.includes(m.unitCode));
    // 只有当 isHasAny 为 true 并且 measure 中有 unitCode 在 rows.chooseFields 中时，才添加 measure
    const shouldAddMeasure = isHasAny && hasMeasureInRows;
    const ret = [
      ...rows.chooseFields,
      ...(shouldAddMeasure ? measure : []),
    ].filter(
      (v) =>
        !drillField.drillFieldsBreadcrumb
          .slice(0, -1)
          .map((v) => v.value)
          .includes(v.unitCode)
    );
    drillFieldClone.chooseFields.push(...ret);
    if (colorDim.length > 0) {
      const ret = colorDim.filter(
        (v) =>
          !drillField.drillFieldsBreadcrumb
            .slice(0, -1)
            .map((v) => v.value)
            .includes(v.unitCode)
      );
      // drillFieldClone.chooseFields.push(...ret);
    }
    rows = drillFieldClone;
  }
  return rows;
}

function getCodeByCubeField(data) {
  return (
    data.chooseFields?.filter((v) => !!v)?.map((item) => item.unitCode) ?? []
  );
}

function getFields(data) {
  return data.chooseFields && data.chooseFields.length
    ? data.chooseFields?.filter((v) => !!v)
    : [];
}
// 根据fields获取类别维度、度量、颜色维度
function getCategoryDimension(data) {
  const getValues = (row) => getCodeByCubeField(row);
  const isHasAny = data.some(
    (item) => item.type === "any" && !["drill", "filter"].includes(item.alias)
  );
  if (isHasAny) {
    const rows = getValues(getDimensions(data));
    const columnsOpt = data.find((item) => item.queryType === "columns") ?? {};
    const values = (
      columnsOpt.chooseFields.filter((item) => item.defineType === "measure") ??
      []
    ).map((item) => item.unitCode);
    const columns = (
      columnsOpt.chooseFields.filter(
        (item) => item.defineType === "dimension"
      ) ?? []
    ).map((item) => item.unitCode);
    return {
      rows,
      values,
      columns,
      displayRows: [
        ...getFields(getDimensions(data)),
        ...(columnsOpt.chooseFields.filter(
          (item) => item.defineType === "dimension"
        ) ?? []),
        ...(columnsOpt.chooseFields.filter(
          (item) => item.defineType === "measure"
        ) ?? []),
      ],
    };
  }
  return {
    rows: getValues(getDimensions(data)),
    values: getValues(getMeasures(data)),
    columns: getValues(getColorDimensions(data)),
    displayRows: [
      ...getFields(getDimensions(data)),
      ...getFields(getColorDimensions(data)),
      ...getFields(getMeasures(data)),
    ],
  };
}

function getStyleConfig(data) {
  return data.styleConfig ?? {};
}

function getAllFieldsByFields(fields) {
  return fields.reduce((acc, field) => {
    acc.push(...field.chooseFields);
    return acc;
  }, []);
}

function transferObjectToArray(selectItem) {
  const obj = selectItem.styleConfig?.helperData?.fieldMap ?? {};
  const objCurrentKeys = Object.keys(
    selectItem.styleConfig?.helperData?.fieldMapCurrent ?? {}
  );
  return Object.entries(obj)
    .filter(([key]) => objCurrentKeys.includes(key) && !!key)
    .filter(([key]) => !!key && key !== "undefined")
    .map(([key, value]) => {
      return {
        key,
        ...value,
      };
    });
}

function getColorFieldMap(metaFields, data, widget, isCurrent = false) {
  const isPie = widget.type === "Pie";
  let result = isCurrent ? {} : widget.styleConfig?.helperData?.fieldMap ?? {};
  // 先判断下颜色维度有没有值，没有的话取所有度量
  let fields = getMeasures(metaFields)?.chooseFields?.length
    ? [getMeasures(metaFields)]
    : [];
  const cols =
    getColorDimensions(metaFields)?.chooseFields?.length > 0
      ? [getColorDimensions(metaFields)]
      : [];
  const drillFields =
    getDimensions(metaFields)?.chooseFields?.length > 0
      ? [getDimensions(metaFields)]
      : [];
  const rows =
    getDimensions(metaFields, true)?.chooseFields?.length > 0
      ? [getDimensions(metaFields, true)]
      : [];
  const columns = isPie ? drillFields : cols;
  if (columns.length > 0) {
    const fieldName = columns[0].chooseFields[0]?.unitCode;
    data.forEach((item) => {
      const colorIndex = data.indexOf(item) % chartSeriesColors.length;
      const color =
        widget.styleConfig?.helperData?.fieldMap[item[fieldName]]?.[
          customKey + "seriesColor"
        ];
      result[item[fieldName]] = {
        [customKey + "text"]: item[fieldName],
        [customKey + "seriesColor"]: color || chartSeriesColors[colorIndex],
      };
    });
    return result;
  } else {
    return getAllFieldsByFields(fields).reduce((acc, field, index) => {
      const colorIndex = index % chartSeriesColors.length;
      const color =
        widget.styleConfig?.helperData?.fieldMap[field.unitName]?.[
          customKey + "seriesColor"
        ];
      acc[field.unitName] = {
        [customKey + "text"]: field.unitName,
        [customKey + "seriesColor"]: color || chartSeriesColors[colorIndex],
      };
      return acc;
    }, result);
  }
}

function getFieldValueByCustomKey(obj, key) {
  return obj[customKey + key];
}

function formatIndicatorData(fields, data) {
  const { rows, values } = getCategoryDimension(fields);
  const measureName = fields.find((v) => v.queryType === "values")
    ?.chooseFields[0].unitName;

  // 使用 Map 来跟踪已经出现过的 rowValue，确保每个 rowValue 只取第一次出现的值
  const seenRowValues = new Map();

  return data
    .filter((item) => {
      const rowValue = item[rows[0]];

      // 如果这个 rowValue 还没有出现过，则保留这条记录
      if (!seenRowValues.has(rowValue)) {
        seenRowValues.set(rowValue, true);
        return true;
      }

      // 如果已经出现过，则过滤掉这条记录
      return false;
    })
    .map((item) => {
      return {
        rowValue: item[rows[0]],
        measureValue: item[values[0]],
        measureName,
      };
    });
}

function initWidget(layout) {
  const isHasDrill = layout.fields?.some((f) => f.alias === "drill");
  const isHasFilter = layout.fields?.some((f) => f.alias === "filter");
  if (!isHasDrill) {
    layout.fields?.unshift(defaultDrillField());
  }
  if (!isHasFilter) {
    layout.fields?.push(defaultFilterField());
  }
}

function updatePanelWidget(cur) {
  if (!cur) {
    return;
  }
  initWidget(cur);
  cur.data.meta = [];
  const nameMap = cur.fields.reduce((acc, field) => {
    field.chooseFields.forEach((item) => {
      acc[item.unitCode] = item.name;
      cur.data.meta.push({
        field: item.unitCode,
        name: item.name,
      });
    });
    return acc;
  }, {});
  const metaFieldNameMap = getColorFieldMap(cur.fields, cur.data.data, cur);
  const metaFieldNameMapCurrent = getColorFieldMap(
    cur.fields,
    cur.data.data,
    cur,
    true
  );
  cur.styleConfig.helperData = {
    ...cur.styleConfig.helperData,
    fieldMap: metaFieldNameMap,
    fieldMapClone: JSON.parse(JSON.stringify(metaFieldNameMap)),
    fieldMapCurrent: metaFieldNameMapCurrent,
    nameMap,
  };
  if (!cur.styleConfig) {
    cur.styleConfig = {
      ...styleConfig(),
    };
  }
}

function initHeight(...args) {
  this[args[0]] = this.$el.offsetHeight - 16;
}

function initWidth(...args) {
  this[args[0]] = this.$el.offsetWidth;
}

/**
 * 更新图表字段的颜色配置
 * @param {Object} vm - Vue 实例，用于调用 $set
 * @param {Object} selectItem - 选中的图表项
 * @param {Object} item - 字段项，包含 key 和颜色信息
 * @param {string} customKey - 自定义键前缀，如 'w_' 或 'w_'
 * @param {string|null} color - 颜色值，如果为 null/undefined，则从 fieldMapClone 恢复
 * @param {boolean} forceReactive - 是否强制触发响应式更新（用于需要立即更新图表的场景）
 */
function updateFieldMapColor(
  vm,
  selectItem,
  item,
  customKey,
  color = null,
  forceReactive = false
) {
  const helperData = selectItem.styleConfig?.helperData;
  if (!helperData || !helperData.fieldMap) {
    return;
  }

  const fieldMap = helperData.fieldMap;
  const fieldMapClone = helperData.fieldMapClone || {};

  // 确保 fieldMap[item.key] 存在且是响应式的
  if (!fieldMap[item.key]) {
    vm.$set(fieldMap, item.key, {});
  }

  // 确定要设置的颜色值
  let colorValue;
  if (color) {
    // 如果有颜色，使用 item 中的颜色
    colorValue = item[customKey + "seriesColor"];
  } else {
    // 如果没有颜色，尝试从 fieldMapClone 中恢复，否则使用 item 中的颜色
    colorValue =
      fieldMapClone[item.key]?.[customKey + "seriesColor"] ??
      item[customKey + "seriesColor"];
  }

  // 使用 $set 确保响应式更新
  vm.$set(fieldMap[item.key], customKey + "seriesColor", colorValue);

  // 如果需要强制触发响应式更新（用于需要立即更新图表的场景，如柱状图）
  if (forceReactive) {
    // 强制触发 Vue 的响应式更新
    // 通过重新设置 fieldMap 对象来触发 watch，但保留所有数据
    const newFieldMap = { ...fieldMap };
    // 确保新对象中的 item.key 对象也被正确设置
    if (newFieldMap[item.key]) {
      newFieldMap[item.key] = {
        ...newFieldMap[item.key],
        [customKey + "seriesColor"]: colorValue,
      };
    }
    vm.$set(helperData, "fieldMap", newFieldMap);
  }
}

async function exportImage(
  vm,
  previewContainer,
  targetElement,
  title,
  conf = { backgroundColor: "#f0f2f5" }
) {
  if (!previewContainer) {
    vm.$message.error("预览容器未找到");
    return;
  }
  try {
    // 等待图表完全渲染，特别是 Canvas 图表的 HTML 覆盖层
    await vm.$nextTick();
    await new Promise((resolve) => setTimeout(resolve, 800));
    if (!targetElement) {
      vm.$message.error("未找到可导出的内容区域");
      return;
    }
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const second = String(now.getSeconds()).padStart(2, "0");
    const exportTime = `${year}${month}${day}${hour}${minute}${second}`;
    let exportTitle = `${title}-${exportTime}`;
    vm.$prompt("文件名称", "导出", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputValue: exportTitle,
      customClass: "jzliu-bi-engine-export-prompt",
    })
      .then(async ({ value }) => {
        vm.$message.success("导出中，请稍候…");
        // 保存原始滚动位置和样式
        const originalScrollTop = previewContainer.scrollTop;
        const originalScrollLeft = previewContainer.scrollLeft;
        const originalOverflow = previewContainer.style.overflow;
        const originalHeight = previewContainer.style.height;
        const originalMaxHeight = previewContainer.style.maxHeight;

        // 临时修改容器样式，确保所有内容都可见
        previewContainer.style.overflow = "visible";
        previewContainer.style.height = "auto";
        previewContainer.style.maxHeight = "none";

        // 滚动到顶部，确保从顶部开始捕获
        previewContainer.scrollTop = 0;
        previewContainer.scrollLeft = 0;

        // 等待滚动完成和内容渲染
        await new Promise((resolve) => setTimeout(resolve, 200));

        // 获取实际内容尺寸（使用 scrollHeight 和 scrollWidth 获取完整内容）
        const contentWidth =
          targetElement.scrollWidth || targetElement.offsetWidth;
        const contentHeight =
          (targetElement.scrollHeight || targetElement.offsetHeight) + 50;
        // 使用 html2canvas 捕获整个预览区域
        // 添加更多配置以确保正确捕获 Canvas 图表的 HTML 覆盖层（如仪表板的数值显示）
        const canvas = await html2canvas(targetElement, {
          backgroundColor: "#f0f2f5",
          ignoreElements: (node) => {
            return node.classList.contains("jzliu-preview-header");
          },
          scale: 2, // 提高图片清晰度
          useCORS: true, // 允许跨域图片
          logging: false,
          width: contentWidth,
          height: contentHeight,
          windowWidth: contentWidth,
          windowHeight: contentHeight,
          scrollX: 0,
          scrollY: 0,
          x: 0,
          y: 0,
          allowTaint: false, // 不允许污染 canvas
          // foreignObjectRendering: true, // 启用外部对象渲染，确保 HTML 内容正确渲染
          removeContainer: false, // 不移除容器
          imageTimeout: 15000, // 图片加载超时时间
          ...conf,
        });

        // 恢复原始样式和滚动位置
        previewContainer.style.overflow = originalOverflow;
        previewContainer.style.height = originalHeight;
        previewContainer.style.maxHeight = originalMaxHeight;
        previewContainer.scrollTop = originalScrollTop;
        previewContainer.scrollLeft = originalScrollLeft;
        // 将 canvas 转换为图片并下载
        const dataURL = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.download = `${value}.png`;
        link.href = dataURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        vm.$message.success("图片导出成功");
        setTimeout(() => {
          vm.exportingImage = false;
          vm.previewDialogVisible = false;
        }, 500);
      })
      .catch(() => {
        setTimeout(() => {
          vm.exportingImage = false;
          vm.previewDialogVisible = false;
        }, 500);
        vm.$message({
          type: "info",
          message: "取消输入",
        });
      });
  } catch (error) {
    console.error("导出图片失败:", error);
    vm.$message.error("导出图片失败: " + (error.message || "未知错误"));
  } finally {
    
  }
}

function getSeriesFieldValues(
  widget,
  colorField = "seriesField",
  xField = "xField"
) {
  const result = {
    [colorField]: {},
    [xField]: {},
  };
  // 判断下是否开启下钻
  const drillFieldsBreadcrumb =
    widget.fields.find((f) => f.alias === "drill")?.drillFieldsBreadcrumb ?? [];
  const isHasDrill = widget.fields.some(
    (f) => f.alias === "drill" && drillFieldsBreadcrumb?.length > 0
  );
  let lastDrillField = {};
  if (isHasDrill) {
    lastDrillField = drillFieldsBreadcrumb[drillFieldsBreadcrumb.length - 1];
  }
  widget.fields.forEach((field) => {
    if (["dimension", "drill"].includes(field.alias)) {
      // 如果有customSortOrder字段，则按照customSortOrder字段排序
      field.chooseFields.forEach((item) => {
        if (item.customSortOrder) {
          // 如果开启了下钻，那xField.values就要取lastDrillField.value和item.unitCode一致
          if (isHasDrill && field.alias === "drill") {
            if (item.unitCode === lastDrillField.value) {
              result[xField].values = item.customSortOrder;
            }
          } else if (field.queryType === "rows") {
            // 如果开启了下钻，需要检查 item.unitCode 是否与 lastDrillField.value 一致
            if (isHasDrill && lastDrillField.value) {
              if (item.unitCode === lastDrillField.value) {
                result[xField].values = item.customSortOrder;
              }
            } else {
              // 没有开启下钻，直接设置
              result[xField].values = item.customSortOrder;
            }
          } else {
            // 没有开启下钻，直接设置
            result[colorField].values = item.customSortOrder;
          }
        }
      });
    }
  });
  console.log(result, 'getSeriesFieldValues',widget.fields)
  return result;
}

function isCustomSortOrderWidget(widget) {
  return ![widgetTypeMap.Gauge].includes(widget.type);
}

export {
  exportImage,
  getMeasures,
  getDimensions,
  getColorDimensions,
  getCategoryDimension,
  getStyleConfig,
  getCodeByCubeField,
  formatIndicatorData,
  getColorFieldMap,
  getAllFieldsByFields,
  transferObjectToArray,
  getFieldValueByCustomKey,
  updatePanelWidget,
  initHeight,
  initWidth,
  isCustomSortOrderWidget,
  updateFieldMapColor,
  getSeriesFieldValues,
  initWidget,
};
